import appConfig from 'config/appConfig'

export const EMAIL_REGEX =
  /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i

export const DOMAIN_REGEX = /^[a-z0-9\-._]{1,255}$/i

export const IP_V4_REGEX =
  /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/

export const HOSTNAME_REGEX = /^([a-z0-9\-_.]+(:[0-9]+)?)$/i

export const US_NUMBER_REGEX = /^\(?\d{3}\)?[.\-\s]?\d{3}[.\-\s]?\d{4}$/

export const HAS_TLD_REGEX = /\.[a-z]{2,63}$/gi

export const isEmailValid = (email: string) => EMAIL_REGEX.test(email.toLowerCase())

export const isDomainValid = (domain: string) => DOMAIN_REGEX.test(domain.toLowerCase())

export const isEmailOrDomainValid = (emailOrDomain: string) => {
  if (emailOrDomain.includes('@')) {
    return isEmailValid(emailOrDomain)
  }
  return isDomainValid(emailOrDomain)
}

export const isPolicyNameValid = (domainOrEmail: string) => {
  if (domainOrEmail.indexOf('@') !== -1) {
    return isEmailValid(domainOrEmail)
  }
  return isDomainValid(domainOrEmail)
}

export const isPolicyValid = (policy: string) => {
  const pol = policy.toLowerCase()
  return pol === 'block' || pol === 'exempt' || pol === 'quarantine'
}

export const isValidIpV4Address = (ipAddress: string) => IP_V4_REGEX.test(ipAddress)

export const hasTld = (domainName: string) => HAS_TLD_REGEX.test(domainName.toLowerCase())

export const isUsNumber = (number: string) => US_NUMBER_REGEX.test(number)

export const isValidHostName = (hostName: string) => HOSTNAME_REGEX.test(hostName)

export const isValidRegex = (pattern: string): boolean => {
  try {
    // eslint-disable-next-line no-new
    new RegExp(pattern)
    return true
  } catch {
    return false
  }
}
